var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricIconParticipantActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16953_359)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5.81818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 5.06818,
    stroke: "#8852D2",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16953_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 19C14.5674 19 16.75 16.8174 16.75 14.125C16.75 11.4326 14.5674 9.25 11.875 9.25C9.18261 9.25 7 11.4326 7 14.125C7 16.8174 9.18261 19 11.875 19Z",
    stroke: "#8852D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95898 22.75C5.70813 21.5982 6.73311 20.6517 7.94086 19.9965C9.14861 19.3412 10.5009 18.998 11.8749 18.998C13.249 18.998 14.6012 19.3412 15.809 19.9965C17.0167 20.6517 18.0417 21.5982 18.7909 22.75",
    stroke: "#8852D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19C21.499 18.9992 22.8513 19.3418 24.0592 19.9967C25.267 20.6517 26.292 21.5981 27.0409 22.75",
    stroke: "#8852D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3145 9.59687C18.9813 9.3309 19.6987 9.2155 20.4153 9.25893C21.1319 9.30235 21.8301 9.50352 22.46 9.84806C23.0899 10.1926 23.6359 10.672 24.059 11.252C24.4821 11.8321 24.7718 12.4984 24.9076 13.2034C25.0433 13.9084 25.0216 14.6346 24.8441 15.3303C24.6666 16.026 24.3376 16.6738 23.8807 17.2276C23.4238 17.7814 22.8502 18.2274 22.2009 18.5338C21.5516 18.8402 20.8427 18.9994 20.1248 19",
    stroke: "#8852D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.296094,
    y: 0.296094,
    width: 31.4,
    height: 31.4,
    rx: 4.7,
    stroke: "#8852D2",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16953_359"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16953_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconParticipantActivity);
export default __webpack_public_path__ + "static/media/MetricIconParticipant-activity.558efb6b77d1131e90eaf84dc44e89dc.svg";
export { ForwardRef as ReactComponent };